import { Box, BoxProps } from '@chakra-ui/react'

export const TickIcon = ({ ...props }: BoxProps) => {
    return (
        <Box {...props}>
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.3335 9.8335L5.66683 12.1668L12.6668 4.8335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </Box>
    )
}
